import type { DateRangeGeneric } from '../types/common';
import dateUtil from './dateUtil';

const isDateRangeValid = (dateRange: DateRangeGeneric<string>): boolean =>
  dateUtil(dateRange.min) <= dateUtil(dateRange.max);

export default isDateRangeValid;
